var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_2892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.71411 11.7857H17.2855",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8.64282V11.7857",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07129 11.7857C7.07129 15.4314 10.4656 18.5114 14.9284 21.2143",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9284 11.7857C15.007 15.4314 11.5341 18.5114 7.07129 21.2143",
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.785645 6.28571C0.785645 4.82701 1.36511 3.42806 2.39656 2.39662C3.428 1.36517 4.82695 0.785706 6.28564 0.785706",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71411 6.28572C4.71411 5.86895 4.87968 5.46926 5.17437 5.17455C5.46907 4.87986 5.86877 4.71429 6.28554 4.71429",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7141 0.785706C17.1729 0.785706 18.5718 1.36517 19.6032 2.39662C20.6347 3.42806 21.2141 4.82701 21.2141 6.28571",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7141 4.71429C16.1309 4.71429 16.5306 4.87986 16.8253 5.17455C17.1199 5.46926 17.2855 5.86895 17.2855 6.28572",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_2892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutIcon);
export default __webpack_public_path__ + "static/media/layoutIcon.aaa73893f49c7fb95ab494f22f6dd938.svg";
export { ForwardRef as ReactComponent };